var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 274,
    viewBox: "0 0 218 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.12 36.12V273.37H180.87H184.71H217.42V240.65V36.12H48.12Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.56 28.56V265.81H173.31H177.15H209.86V233.09V28.56H40.56Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21V258.25H165.75H169.59H202.3V225.53V21H33Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5489 168H152.549",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5489 184H152.549",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5489 200H152.549",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.756 127.63V135.411C112.756 142.005 106.622 147.333 99.0708 147.333C91.5192 147.333 85.3474 142.005 85.3474 135.411V127.63C85.3474 134.223 91.4808 138.9 99.0708 138.9C106.622 138.9 112.756 134.185 112.756 127.63Z",
    stroke: "#6CCA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.756 117.087C112.756 119.004 112.22 120.767 111.3 122.301C109.038 126.019 104.4 128.357 99.0331 128.357C93.6664 128.357 89.0281 125.981 86.7664 122.301C85.8464 120.767 85.3099 119.004 85.3099 117.087C85.3099 113.791 86.8432 110.839 89.2965 108.692C91.7882 106.507 95.1997 105.204 98.9947 105.204C102.79 105.204 106.202 106.546 108.693 108.692C111.223 110.801 112.756 113.791 112.756 117.087Z",
    stroke: "#6CCA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.756 117.088V127.63C112.756 134.223 106.622 138.9 99.0708 138.9C91.5192 138.9 85.3474 134.185 85.3474 127.63V117.088C85.3474 110.495 91.4808 105.167 99.0708 105.167C102.866 105.167 106.278 106.508 108.769 108.655C111.223 110.802 112.756 113.792 112.756 117.088Z",
    stroke: "#6CCA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.883 105.052V112.949C155.883 115.057 154.196 116.782 152.05 116.859H144.536C140.396 116.859 136.601 113.831 136.256 109.691C136.026 107.276 136.946 105.014 138.556 103.442C139.975 101.986 141.93 101.142 144.076 101.142H152.05C154.196 101.219 155.883 102.944 155.883 105.052Z",
    stroke: "#292D32",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2156 103.25V95.5833C79.2156 85.1567 85.5022 77.8733 95.2772 76.6467C96.2739 76.4933 97.3089 76.4167 98.3822 76.4167H132.882C133.879 76.4167 134.837 76.455 135.757 76.6083C145.647 77.7583 152.049 85.08 152.049 95.5833V101.142H144.076C141.929 101.142 139.974 101.985 138.556 103.442C136.946 105.013 136.026 107.275 136.256 109.69C136.601 113.83 140.396 116.858 144.536 116.858H152.049V122.417C152.049 133.917 144.382 141.583 132.882 141.583H123.299",
    stroke: "#292D32",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5641,
    cy: 43.5512,
    r: 34.4359,
    fill: "#BADEAC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4615,
    cy: 36.4615,
    r: 34.7253,
    fill: "#6CCA36",
    stroke: "black",
    strokeWidth: 3.47253
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyWallet);
export default __webpack_public_path__ + "static/media/verify-wallet.689d0ee444d4d8141d810e760c6ca808.svg";
export { ForwardRef as ReactComponent };